var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11,.cls-5,.cls-9{fill:none;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-4,.cls-9{stroke:#b2c8cf;}.cls-1,.cls-4,.cls-9{stroke-linecap:round;}.cls-1,.cls-10,.cls-4,.cls-9{stroke-linejoin:round;}.cls-2{fill:#6e95a3;}.cls-3,.cls-4{fill:#316579;}.cls-6{fill:#003c55;}.cls-7{fill:#b2c8cf;}.cls-8{fill:#346679;}.cls-11,.cls-12,.cls-13{stroke-miterlimit:10;}.cls-12,.cls-14{fill:#7096a4;}.cls-13{fill:#003d55;}.cls-15{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_241",
    "data-name": "Groupe 241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1560",
    "data-name": "Trac\\xE9 1560",
    className: "cls-1",
    d: "M164,177.16l6-3.63v-30l-6.36,3.66"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_405",
    "data-name": "Ligne 405",
    className: "cls-1",
    x1: 152.22,
    y1: 183.8,
    x2: 155.07,
    y2: 182.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1561",
    "data-name": "Trac\\xE9 1561",
    className: "cls-1",
    d: "M141.23,159.63l-125.89,73v30.16l126.49-73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1562",
    "data-name": "Trac\\xE9 1562",
    className: "cls-1",
    d: "M147.1,90.46V8.87l-108,111.45V219L142.7,102.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1563",
    "data-name": "Trac\\xE9 1563",
    className: "cls-1",
    d: "M15.34,262.83.5,254V224.55l14.84,8.12v-99L39.53,119.8l-15-8.55L.5,125.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1564",
    "data-name": "Trac\\xE9 1564",
    className: "cls-1",
    d: "M15.34,133.65.5,125.14v99.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1565",
    "data-name": "Trac\\xE9 1565",
    className: "cls-1",
    d: "M24.51,111.25l109-110.13L147.1,8.87"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_406",
    "data-name": "Ligne 406",
    className: "cls-1",
    x1: 170.09,
    y1: 143.5,
    x2: 163.07,
    y2: 140.35
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_407",
    "data-name": "Ligne 407",
    className: "cls-1",
    x1: 136.09,
    y1: 146.38,
    x2: 68.85,
    y2: 185.14
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_408",
    "data-name": "Ligne 408",
    className: "cls-1",
    x1: 33.18,
    y1: 222.39,
    x2: 21.29,
    y2: 259.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_409",
    "data-name": "Ligne 409",
    className: "cls-1",
    x1: 45.48,
    y1: 215.52,
    x2: 33.59,
    y2: 252.53
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_410",
    "data-name": "Ligne 410",
    className: "cls-1",
    x1: 59.26,
    y1: 207.31,
    x2: 47.37,
    y2: 244.32
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_411",
    "data-name": "Ligne 411",
    className: "cls-1",
    x1: 71.56,
    y1: 200.45,
    x2: 59.67,
    y2: 237.46
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_412",
    "data-name": "Ligne 412",
    className: "cls-1",
    x1: 85.33,
    y1: 192.24,
    x2: 73.45,
    y2: 229.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_413",
    "data-name": "Ligne 413",
    className: "cls-1",
    x1: 97.63,
    y1: 185.37,
    x2: 85.75,
    y2: 222.39
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_414",
    "data-name": "Ligne 414",
    className: "cls-1",
    x1: 111.41,
    y1: 177.16,
    x2: 99.52,
    y2: 214.18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_415",
    "data-name": "Ligne 415",
    className: "cls-1",
    x1: 123.71,
    y1: 170.3,
    x2: 111.82,
    y2: 207.31
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_416",
    "data-name": "Ligne 416",
    className: "cls-1",
    x1: 137.49,
    y1: 162.09,
    x2: 125.6,
    y2: 199.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_417",
    "data-name": "Ligne 417",
    className: "cls-1",
    x1: 141.47,
    y1: 181.12,
    x2: 138.09,
    y2: 191.64
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_418",
    "data-name": "Ligne 418",
    className: "cls-1",
    x1: 154.75,
    y1: 174.48,
    x2: 151.68,
    y2: 184.03
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_419",
    "data-name": "Ligne 419",
    className: "cls-1",
    x1: 170.09,
    y1: 158.13,
    x2: 163.98,
    y2: 177.16
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_420",
    "data-name": "Ligne 420",
    className: "cls-1",
    x1: 53.31,
    y1: 136.82,
    x2: 119.02,
    y2: 68.12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_421",
    "data-name": "Ligne 421",
    className: "cls-1",
    x1: 53.31,
    y1: 155.54,
    x2: 119.02,
    y2: 86.84
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_422",
    "data-name": "Ligne 422",
    className: "cls-1",
    x1: 53.31,
    y1: 174.25,
    x2: 119.02,
    y2: 105.55
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1566",
    "data-name": "Trac\\xE9 1566",
    className: "cls-2",
    d: "M229.8,74.51v5.15l5.66,3.08L235,76.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1567",
    "data-name": "Trac\\xE9 1567",
    className: "cls-3",
    d: "M237.42,46.4c1.4-3.22,5.73-5.44,8.35-4.38s6.46,2.83,6.5,7.15a46.91,46.91,0,0,1-.22,6L249.17,57l-2.43-3.29-.81-2.07-4.1.63-5.21-3.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    className: "cls-4",
    cx: 381.68,
    cy: 240.3,
    r: 2.71
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1568",
    "data-name": "Trac\\xE9 1568",
    className: "cls-3",
    d: "M418.7,363.57c0,7.73-11.88,14-26.54,14s-26.55-6.26-26.55-14c0-4.82,4.62-9.07,11.66-11.59.3-.11,0,2.18.11,2.49.22.6.45,2.28,1.59,2,.56-.13,0,.5,2.18.87a20.78,20.78,0,0,0,3.7,0c.4-.06,2.65-1.21,3-2.38a15.87,15.87,0,0,0,.23-5.28c1.39-.12,2.66-.12,4.11-.12.31,0,.4,2.73.7,2.74s.85,2,1.1,2.05a10.77,10.77,0,0,1,2.93.93c.49.16,2.48.81,3.32-.26s2.82-1,1.76-4.48c9.8,2.06,16.73,7.1,16.73,13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1569",
    "data-name": "Trac\\xE9 1569",
    className: "cls-2",
    d: "M393,352.66v5.54a4.07,4.07,0,0,0,3.35,4l10.51,3.57a3.54,3.54,0,0,0,2.67-6.38l-7.3-8.14-.43,2.38-1.18,1.2-1.74.7-1.95-.24-2.07-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1570",
    "data-name": "Trac\\xE9 1570",
    className: "cls-2",
    d: "M388.09,353.64c4.16,8.73-.4,12.38-8.23,12.37-7.43,0-3.44-9.6-2.54-12.37l.35,1.55,1.3,1.3,3.24,1.15,2.3-.2,2.07-.84,1.11-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1571",
    "data-name": "Trac\\xE9 1571",
    className: "cls-1",
    d: "M393,352.66v5.54a4.07,4.07,0,0,0,3.35,4l10.51,3.57a3.54,3.54,0,0,0,2.67-6.38l-7.2-8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1572",
    "data-name": "Trac\\xE9 1572",
    className: "cls-1",
    d: "M377.32,353.64c-.9,2.77-4.9,12.36,2.54,12.37,7.83,0,12.39-3.64,8.23-12.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1573",
    "data-name": "Trac\\xE9 1573",
    className: "cls-5",
    d: "M377.07,295.94l.23,57.88c0,4.5,10.7,5.48,10.7,0l.43-38.38a1.13,1.13,0,0,1,1.15-1.11,1.14,1.14,0,0,1,1.11,1.07l1.95,35.67c0,5.1,9.71,6.5,9.64.36,0,0-1.11-49.72-1.47-55.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1574",
    "data-name": "Trac\\xE9 1574",
    className: "cls-1",
    d: "M377.07,295.94l.23,57.88c0,4.5,10.7,5.48,10.7,0l.43-38.38a1.13,1.13,0,0,1,1.15-1.11,1.14,1.14,0,0,1,1.11,1.07l1.95,35.67c0,5.1,9.71,6.5,9.64.36,0,0-1.11-49.72-1.47-55.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1575",
    "data-name": "Trac\\xE9 1575",
    className: "cls-3",
    d: "M221.05,164.12c0,7.73,11.89,14,26.55,14s26.54-6.26,26.54-14c0-4.82-4.62-9.07-11.65-11.58-.3-.11,0,2.18-.11,2.48-.23.6-.46,2.29-1.6,2-.55-.13,0,.5-2.18.88a22.85,22.85,0,0,1-3.7,0c-.4-.07-2.64-1.21-3-2.38a15.94,15.94,0,0,1-.23-5.29c-1.39-.12-2.66-.12-4.11-.12-.3,0-.4,2.74-.7,2.74s-.84,2-1.1,2a11.24,11.24,0,0,0-2.93.93c-.49.16-2.48.81-3.31-.26s-2.83-1-1.76-4.47c-9.8,2-16.74,7.1-16.74,13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1576",
    "data-name": "Trac\\xE9 1576",
    className: "cls-2",
    d: "M246.8,153.22v5.53a4.07,4.07,0,0,1-3.35,4l-10.51,3.58a3.54,3.54,0,0,1-2.67-6.38l7.3-8.15.43,2.38,1.18,1.2,1.74.7,2-.24,2.07-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1577",
    "data-name": "Trac\\xE9 1577",
    className: "cls-2",
    d: "M251.66,154.19c-4.16,8.73.4,12.38,8.23,12.37,7.44,0,3.45-9.6,2.54-12.37l-.34,1.55-1.3,1.3-3.24,1.15-2.3-.2-2.07-.83-1.11-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1578",
    "data-name": "Trac\\xE9 1578",
    className: "cls-1",
    d: "M246.8,153.22v5.53a4.07,4.07,0,0,1-3.35,4l-10.51,3.58a3.54,3.54,0,0,1-2.67-6.38l7.2-8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1579",
    "data-name": "Trac\\xE9 1579",
    className: "cls-1",
    d: "M262.43,154.19c.91,2.77,4.9,12.37-2.54,12.37-7.83,0-12.39-3.64-8.23-12.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1580",
    "data-name": "Trac\\xE9 1580",
    className: "cls-5",
    d: "M262.68,96.5l-.23,57.88c0,4.5-10.7,5.48-10.7,0L251.33,116a1.13,1.13,0,0,0-2.26,0l-2,35.68c0,5.1-9.7,6.5-9.64.36,0,0,1.12-49.72,1.48-55.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1581",
    "data-name": "Trac\\xE9 1581",
    className: "cls-1",
    d: "M262.68,96.5l-.23,57.88c0,4.5-10.7,5.48-10.7,0L251.33,116a1.13,1.13,0,0,0-2.26,0l-2,35.68c0,5.1-9.7,6.5-9.64.36,0,0,1.12-49.72,1.48-55.21C241.3,101.8,257.07,106.94,262.68,96.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1582",
    "data-name": "Trac\\xE9 1582",
    className: "cls-5",
    d: "M388.37,257.94a6.57,6.57,0,0,1-5.85-6.52v-6.6a6.59,6.59,0,1,1,13.17,0v6.6a6.45,6.45,0,0,1-1.22,3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1583",
    "data-name": "Trac\\xE9 1583",
    className: "cls-1",
    d: "M395.69,251.42v-6.6a6.59,6.59,0,1,0-13.17,0v6.6a6.39,6.39,0,0,0,5.85,6.52C395,258.2,395.69,252.81,395.69,251.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1584",
    "data-name": "Trac\\xE9 1584",
    className: "cls-6",
    d: "M392.76,250.53c0,.32.15.59.34.59s.34-.27.34-.59-.16-.59-.34-.59-.34.26-.34.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1585",
    "data-name": "Trac\\xE9 1585",
    className: "cls-7",
    d: "M392.76,250.53c0,.32.15.59.34.59s.34-.27.34-.59-.16-.59-.34-.59S392.76,250.2,392.76,250.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1586",
    "data-name": "Trac\\xE9 1586",
    className: "cls-6",
    d: "M389,251c0,.32.15.59.34.59s.34-.27.34-.59-.15-.59-.34-.59-.34.26-.34.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1587",
    "data-name": "Trac\\xE9 1587",
    className: "cls-7",
    d: "M389,251c0,.32.15.59.34.59s.34-.27.34-.59-.15-.59-.34-.59S389,250.66,389,251Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1588",
    "data-name": "Trac\\xE9 1588",
    className: "cls-8",
    d: "M395.63,244.31c-.39-5.89-6-6-7.5-6-4.6.18-7.88,3.18-7.59,9.77,0,.65,1.28,8.08,1.28,7.43,0-.38,4.26,4.44,4.82,3-1.08-2.28-2.14-12.9-2.14-12.9a11.72,11.72,0,0,0,11.13-1.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1589",
    "data-name": "Trac\\xE9 1589",
    className: "cls-1",
    d: "M395.63,244.31c-.39-5.89-6-6-7.5-6-4.6.18-8,2.25-7.71,8.84,0,.65,1.4,9,1.4,8.36s5.45,4.1,5.45,4.1c-1.44-1.08-3.5-14.24-2.77-14A13,13,0,0,0,395.63,244.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1590",
    "data-name": "Trac\\xE9 1590",
    className: "cls-1",
    d: "M393.1,256.76v3.79c0,1.45-3.22,2.16-4.6,2.16a5.86,5.86,0,0,1-4-2v-3.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1591",
    "data-name": "Trac\\xE9 1591",
    className: "cls-1",
    d: "M404.18,215.09l8-4a1.33,1.33,0,0,1,1.77.59,1.38,1.38,0,0,1,.14.59h0a1.31,1.31,0,0,1-.73,1.18l-81.2,40.88a1.32,1.32,0,0,1-1.77-.58,1.39,1.39,0,0,1-.14-.6v-.2a1.31,1.31,0,0,1,.73-1.18l22.86-11.45"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_423",
    "data-name": "Ligne 423",
    className: "cls-1",
    x1: 359.5,
    y1: 237.47,
    x2: 398.33,
    y2: 218.02
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1592",
    "data-name": "Trac\\xE9 1592",
    className: "cls-1",
    d: "M353.51,240.47s1-3.16,2.29-3.76c2.3-1,3.8-1,3.71,1.22s-3.91,2.54-3.91,2.54Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_234",
    "data-name": "Groupe 234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1593",
    "data-name": "Trac\\xE9 1593",
    className: "cls-1",
    d: "M360.57,240.61l3.6,11.25,8,8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1594",
    "data-name": "Trac\\xE9 1594",
    className: "cls-1",
    d: "M368.29,266.5,358.78,256a3.25,3.25,0,0,1-.78-1.31l-3.48-11.58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_235",
    "data-name": "Groupe 235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1595",
    "data-name": "Trac\\xE9 1595",
    className: "cls-1",
    d: "M406,217.18l-.31,25.5a2.43,2.43,0,0,1,0,.38l-1.71,13.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1596",
    "data-name": "Trac\\xE9 1596",
    className: "cls-1",
    d: "M397.47,253.85l1.45-11.45.31-21.82"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1597",
    "data-name": "Trac\\xE9 1597",
    className: "cls-1",
    d: "M384.53,260.71a30.36,30.36,0,0,0-5.19,2.11c-2.09,1.18-3.29-.38-7.14-2.8,1.05,2.21-.74,5.71-3.91,6.48.95,4,6.3,5.06,6.89,8.95s1.9,18.84,1.9,20.49c3.17,7.9,23.74,5.8,23.74.28S398,281.14,398,279.39s1.27-3.56,1.76-4.64-.82-3.16-1.23-4.91,5.85-10.52,5.4-13.63c-2.29,2.17-6.93.55-6.44-2.35-.3,0-1.91,2.32-4.38,3.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1598",
    "data-name": "Trac\\xE9 1598",
    className: "cls-1",
    d: "M397.93,218.42s1-3.16,2.3-3.76c2.29-1,3.8-1,3.7,1.21s-3.91,2.55-3.91,2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1600",
    "data-name": "Trac\\xE9 1600",
    className: "cls-1",
    d: "M329.76,260.72v2.18c0,.5.77.9,1.72.9s1.72-.4,1.72-.9v-2.18c0,.5-.77.91-1.72.91s-1.72-.41-1.72-.91.77-.91,1.72-.91,1.72.41,1.72.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1601",
    "data-name": "Trac\\xE9 1601",
    className: "cls-1",
    d: "M328.14,263.45V276c0,1,1.5,3.45,3.34,3.45s3.34-2.48,3.34-3.45V263.45c0,1-1.5,1.76-3.34,1.76s-3.34-.79-3.34-1.76,1.5-1.76,3.34-1.76,3.34.79,3.34,1.76"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_424",
    "data-name": "Ligne 424",
    className: "cls-1",
    x1: 331.48,
    y1: 260.12,
    x2: 331.48,
    y2: 254.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1602",
    "data-name": "Trac\\xE9 1602",
    className: "cls-1",
    d: "M333.81,253.5c3.8.68,15.11-1.81,21.18-8.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1603",
    "data-name": "Trac\\xE9 1603",
    className: "cls-1",
    d: "M361.84,236.3c1.39-7.83,24.08-2.16,25.84-9.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1604",
    "data-name": "Trac\\xE9 1604",
    className: "cls-1",
    d: "M391.54,221.43c-.15-2.26,13.26-2.72,15.85,2.74s1.65,13.56-1.77,18.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1605",
    "data-name": "Trac\\xE9 1605",
    className: "cls-1",
    d: "M401.43,263.17c1.24,4.46,6,13.68-1.65,25.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1606",
    "data-name": "Trac\\xE9 1606",
    className: "cls-1",
    d: "M226.74,72.1V81L235.46,86V76.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1607",
    "data-name": "Trac\\xE9 1607",
    className: "cls-1",
    d: "M235.46,76.92l3.91-3.52-3-1.3h-9.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1608",
    "data-name": "Trac\\xE9 1608",
    className: "cls-1",
    d: "M235.46,86l3.91-6.38V73.4l1.52-.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1609",
    "data-name": "Trac\\xE9 1609",
    className: "cls-1",
    d: "M229.8,73.8v5.86l5.66,3.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1610",
    "data-name": "Trac\\xE9 1610",
    className: "cls-1",
    d: "M238.94,96.78c-.18-2.32,1.63-16.86.43-17.12l2.55-1.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1611",
    "data-name": "Trac\\xE9 1611",
    className: "cls-1",
    d: "M262.68,96.49c0-1.5-1-3.1-1-4.27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_236",
    "data-name": "Groupe 236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1612",
    "data-name": "Trac\\xE9 1612",
    className: "cls-1",
    d: "M261.11,67.63c2.11.23,3.13,2.05,2.9,4.16l-2.28,20.43a3.84,3.84,0,0,1-6.54,2.29L244.76,84.08a3.84,3.84,0,0,1,5.39-5.47l0,0L255,83.42l.88-7.94"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1613",
    "data-name": "Trac\\xE9 1613",
    className: "cls-1",
    d: "M231.57,72.1v-7c0-3.16,2.06-6.15,5.2-5.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1614",
    "data-name": "Trac\\xE9 1614",
    className: "cls-1",
    d: "M243.62,80.06l-.9-.9a3.83,3.83,0,0,1-1.12-2.4l-.2-2.42a2.12,2.12,0,0,0-1.21-2.18L239,71.6a2.35,2.35,0,0,1-.61-3.26,1.84,1.84,0,0,1,.17-.22h0a2.33,2.33,0,0,1,3.19-.3c.78.6,1.66,1.17,2,1.5.51.54,1.69,1.25,1.69,2.58v4l.88,1.77"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_425",
    "data-name": "Ligne 425",
    className: "cls-1",
    x1: 236.37,
    y1: 72.1,
    x2: 238.47,
    y2: 71.11
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1615",
    "data-name": "Trac\\xE9 1615",
    className: "cls-1",
    d: "M258.5,60.51l-11,5.77-4.7-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1616",
    "data-name": "Trac\\xE9 1616",
    className: "cls-1",
    d: "M261,63.64l-10.91,6V78.5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_426",
    "data-name": "Ligne 426",
    className: "cls-1",
    x1: 247.47,
    y1: 66.28,
    x2: 250.08,
    y2: 69.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    className: "cls-9",
    cx: 234.15,
    cy: 65.78,
    rx: 0.78,
    ry: 1.84,
    transform: "translate(-4.13 114.54) rotate(-27.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1617",
    "data-name": "Trac\\xE9 1617",
    className: "cls-1",
    d: "M242.24,58.83c.39-.2,1.08.37,1.54,1.28s.53,1.8.15,2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1618",
    "data-name": "Trac\\xE9 1618",
    className: "cls-1",
    d: "M233.3,64.14l9.91-5.93,3,.57,5.81-3.57L257,58l1.5.92v1.62L261,63.64v8.84l-10.85,6.34"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_427",
    "data-name": "Ligne 427",
    className: "cls-1",
    x1: 234.99,
    y1: 67.42,
    x2: 253.82,
    y2: 56.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_428",
    "data-name": "Ligne 428",
    className: "cls-1",
    x1: 240.89,
    y1: 67.33,
    x2: 242.77,
    y2: 62.78
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1619",
    "data-name": "Trac\\xE9 1619",
    className: "cls-1",
    d: "M240.89,67.16c2-1,4.74.53,6.23,3.42s1.12,6.06-.83,7.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1620",
    "data-name": "Trac\\xE9 1620",
    className: "cls-4",
    d: "M251.47,71.89v2.2l3.11-1.74V70.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1621",
    "data-name": "Trac\\xE9 1621",
    className: "cls-1",
    d: "M252.3,55.21V49.87a7.84,7.84,0,0,0-15.68,0v7.91a8,8,0,0,0,.8,3.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1622",
    "data-name": "Trac\\xE9 1622",
    className: "cls-7",
    d: "M239.83,56.73c0,.39-.18.71-.41.71s-.4-.32-.4-.71.18-.71.4-.71S239.83,56.33,239.83,56.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1622-2",
    "data-name": "Trac\\xE9 1622",
    className: "cls-7",
    d: "M243.83,57.73c0,.39-.18.71-.41.71s-.4-.32-.4-.71.18-.71.4-.71S243.83,57.33,243.83,57.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1623",
    "data-name": "Trac\\xE9 1623",
    className: "cls-1",
    d: "M236.84,48c3.36,5.68,7.47,4.72,9.56,2.92,0,1.07-.07,5.24,3.68,5.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1624",
    "data-name": "Trac\\xE9 1624",
    className: "cls-10",
    d: "M399.5,285.5l96-54.62V111.5L290.38,226V347.51l86.7-49.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1625",
    "data-name": "Trac\\xE9 1625",
    className: "cls-1",
    d: "M187.3,234.5,188.46,162,290.38,226V347.51l-46.88-29"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_429",
    "data-name": "Ligne 429",
    className: "cls-11",
    x1: 466.11,
    y1: 94.29,
    x2: 495.5,
    y2: 111.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1626",
    "data-name": "Trac\\xE9 1626",
    className: "cls-11",
    d: "M262.59,119,385.12,47.77l50.35,29.07"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_430",
    "data-name": "Ligne 430",
    className: "cls-11",
    x1: 248.45,
    y1: 127.18,
    x2: 251.43,
    y2: 125.45
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_431",
    "data-name": "Ligne 431",
    className: "cls-11",
    x1: 188.46,
    y1: 162.03,
    x2: 237.91,
    y2: 133.31
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_237",
    "data-name": "Groupe 237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1627",
    "data-name": "Trac\\xE9 1627",
    className: "cls-1",
    d: "M165.54,252.38l32.58-26.08a45.66,45.66,0,0,1,32.67-10C261,219.14,270,249,272.35,263.31c2,14.18,0,30.38-12.15,42.53s-28.35,18.22-28.35,18.22"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1628",
    "data-name": "Trac\\xE9 1628",
    className: "cls-1",
    d: "M147.55,281.27,196,309v95.34L83,339.1V244.27l45.35,26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1629",
    "data-name": "Trac\\xE9 1629",
    className: "cls-1",
    d: "M134.33,292.2l46.26,26.3v57.2L97.11,327.92V271l17.79,10.12"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_432",
    "data-name": "Ligne 432",
    className: "cls-1",
    x1: 122.42,
    y1: 285.43,
    x2: 125.88,
    y2: 287.39
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1630",
    "data-name": "Trac\\xE9 1630",
    className: "cls-1",
    d: "M145.46,240.88l85.62,49v74.26"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_433",
    "data-name": "Ligne 433",
    className: "cls-1",
    x1: 231.08,
    y1: 364.18,
    x2: 196.02,
    y2: 404.38
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_434",
    "data-name": "Ligne 434",
    className: "cls-1",
    x1: 134.7,
    y1: 240.13,
    x2: 82.95,
    y2: 244.27
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_435",
    "data-name": "Ligne 435",
    className: "cls-1",
    x1: 196.02,
    y1: 309.04,
    x2: 231.08,
    y2: 289.92
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1632",
    "data-name": "Trac\\xE9 1632",
    className: "cls-1",
    d: "M361.84,236.3V210.66l96.27-54.46.9,53.91L407.29,240.3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_436",
    "data-name": "Ligne 436",
    className: "cls-1",
    x1: 361.84,
    y1: 244.4,
    x2: 361.84,
    y2: 239.39
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1633",
    "data-name": "Trac\\xE9 1633",
    className: "cls-1",
    d: "M366.08,264.42l-4.24,2.4v-7.18"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_437",
    "data-name": "Ligne 437",
    className: "cls-1",
    x1: 381.82,
    y1: 255.53,
    x2: 372.98,
    y2: 260.52
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_438",
    "data-name": "Ligne 438",
    className: "cls-1",
    x1: 398.55,
    y1: 245.4,
    x2: 396.12,
    y2: 246.81
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1634",
    "data-name": "Trac\\xE9 1634",
    className: "cls-1",
    d: "M239.21,91.71,195,65.7v57.85l29.45,17.57"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_439",
    "data-name": "Ligne 439",
    className: "cls-1",
    x1: 274.14,
    y1: 112.25,
    x2: 262.96,
    y2: 105.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1635",
    "data-name": "Trac\\xE9 1635",
    className: "cls-1",
    d: "M383.06,36.56l-79.68,46.2v68.81l-11.61-7.45V72.31l72.91-43.92,18.38,8.17v75.17l-12.36-5.5-.21-62.41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_238",
    "data-name": "Groupe 238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1636",
    "data-name": "Trac\\xE9 1636",
    className: "cls-12",
    d: "M460.84,172.53l.64,5.06a5.24,5.24,0,0,1-10.39,1.31,4.9,4.9,0,0,1,0-.94l.24-4.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1637",
    "data-name": "Trac\\xE9 1637",
    className: "cls-1",
    d: "M460.84,172.53l.64,5.06a5.24,5.24,0,0,1-10.39,1.31,4.9,4.9,0,0,1,0-.94l.24-4.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1638",
    "data-name": "Trac\\xE9 1638",
    className: "cls-12",
    d: "M473.66,166.37l7.6,5.21a2.23,2.23,0,0,1,.58,3.11,2.38,2.38,0,0,1-.69.65l-2,1.22a4.07,4.07,0,0,1-3.86.19l-8.55-4a4.13,4.13,0,0,1-2.35-3.72v-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1639",
    "data-name": "Trac\\xE9 1639",
    className: "cls-1",
    d: "M473.66,166.37l7.6,5.21a2.23,2.23,0,0,1,.58,3.11,2.38,2.38,0,0,1-.69.65l-2,1.22a4.07,4.07,0,0,1-3.86.19l-8.55-4a4.13,4.13,0,0,1-2.35-3.72v-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1640",
    "data-name": "Trac\\xE9 1640",
    className: "cls-6",
    d: "M452.77,118.43l14.94,10.15a9.72,9.72,0,0,1,4.5,7.74l1.45,29.31a4.69,4.69,0,0,1-4.45,4.91H469a4.69,4.69,0,0,1-4.68-4.46l-1.45-29.5-11.62-7.81a2.29,2.29,0,0,0-2.58,0,.32.32,0,0,0-.07.45.1.1,0,0,0,.05.06l7.26,6a8.53,8.53,0,0,1,3.14,6.2l1.5,30.54a4.68,4.68,0,0,1-4.45,4.91h-.23a4.68,4.68,0,0,1-4.68-4.46L449.71,143l-19.48-13c-4-2.67-1.83-6.39-1.6-9.89l10.6,1.66,7,.18,3.17-1.49,3.4-2.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1641",
    "data-name": "Trac\\xE9 1641",
    className: "cls-1",
    d: "M452.77,118.43l14.94,10.15a9.72,9.72,0,0,1,4.5,7.74l1.45,29.31a4.69,4.69,0,0,1-4.45,4.91H469a4.69,4.69,0,0,1-4.68-4.46l-1.45-29.5-11.62-7.81a2.29,2.29,0,0,0-2.58,0,.32.32,0,0,0-.07.45.1.1,0,0,0,.05.06l7.26,6a8.53,8.53,0,0,1,3.14,6.2l1.5,30.54a4.68,4.68,0,0,1-4.45,4.91h-.23a4.68,4.68,0,0,1-4.68-4.46L449.71,143l-19.48-13c-4-2.67-1.83-6.39-1.6-9.89,1.55.43,15.88,3.32,20,.8l4.13-2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1642",
    "data-name": "Trac\\xE9 1642",
    className: "cls-12",
    d: "M435.86,70.43a2.21,2.21,0,1,0,2.48-1.9h-.29a2.06,2.06,0,0,0-2.19,1.91"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    className: "cls-1",
    cx: 438.05,
    cy: 70.43,
    rx: 2.19,
    ry: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1644",
    "data-name": "Trac\\xE9 1644",
    className: "cls-1",
    d: "M441.58,89.29a6.56,6.56,0,0,1-5.83-6.53V76.13A6.56,6.56,0,0,1,439,70.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1645",
    "data-name": "Trac\\xE9 1645",
    className: "cls-13",
    d: "M446,81.88c0,.33.16.6.34.6s.34-.27.34-.6-.15-.6-.34-.6-.34.26-.34.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1646",
    "data-name": "Trac\\xE9 1646",
    className: "cls-13",
    d: "M442.22,82.35c0,.33.16.6.34.6s.34-.27.34-.6-.15-.6-.34-.6-.34.26-.34.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1647",
    "data-name": "Trac\\xE9 1647",
    className: "cls-12",
    d: "M448.82,75.59c-.38-5.87-6-6-7.48-6-4.59.19-6,3.55-5.67,10.13,0,.64.07,3.23.07,2.58a49.88,49.88,0,0,1,2-5.4c.46,4.38,11.1-1.34,11.1-1.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1648",
    "data-name": "Trac\\xE9 1648",
    className: "cls-1",
    d: "M448.82,75.59c-.38-5.87-6-6-7.48-6-4.59.19-6,3.55-5.67,10.13,0,.64.07,3.23.07,2.58a49.88,49.88,0,0,1,2-5.4C438.18,81.31,448.82,75.59,448.82,75.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1649",
    "data-name": "Trac\\xE9 1649",
    className: "cls-1",
    d: "M447.42,107.25l11.09,1.07M448,105.24,459,106.31m-10.56-3.07,11.09,1.07M449,101.23l11.09,1.07m-10.56-3.08,11.09,1.07m-10.55-3.08,11.08,1.07m-10.55-3.07,11.09,1.07M451.15,93.2l11.09,1.07m-10.55-3.08,11.08,1.07M452.66,76.85,463.42,89.3m-12.9-1,15.31-9.84m-13.17-1.59,13.17,1.59L463.42,89.3l-12.9-1ZM471,74.48c.09-1.33,0-11.06,0-11.06l-7.31,10.34M446.52,86.08a103.89,103.89,0,0,1,3.57-13.66L471,74.48l-9.09,37.29-16.62-1.57m4.19-19.26c-2.53.64-7,0-7.78-1.94M438,103.66l-1,5.06m.36-19.38c-2.26,1.09-7.81,4.2-7.81,4.2a4,4,0,0,0-2.19,5.22L435.23,118a4,4,0,0,0,3.71,2.49h.29a4,4,0,0,0,3.6-3l6.61-26.53a4,4,0,0,0-7.76-2l0,.08-1.31,5.27L438,103.66l-2.26-4.76m17,19.53a6.88,6.88,0,0,0-.53-3.32l-.55-4.31m-22-6.28s.49,8.4-.24,10.55c-1,2.81-1.15,3.34-.85,5.08M440.16,94.2a7,7,0,0,1-2.81-2.13V87"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1650",
    "data-name": "Trac\\xE9 1650",
    className: "cls-3",
    d: "M77.81,377.37c0,7.43-11.43,13.46-25.54,13.46s-25.53-6-25.53-13.46c0-5.84,7.06-10.82,16.93-12.68v6.5l.77,3.44,6.42,1.25,2.6-2.63.1-1.27.21-8.05c.81,0,1.62.07,2.42.14.24,0-.31,7.1-.07,7.12.44,0,.07,1,.42,1.3.55.52,1.52,2.18,2.13,2.07a6.92,6.92,0,0,1,2.4.62l2.75-.84,1.42-1.43.61-1.4s0-5.55.17-5.49c7.09,2.39,11.79,6.58,11.79,11.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1651",
    "data-name": "Trac\\xE9 1651",
    className: "cls-14",
    d: "M65.93,371.19s.9,5.14-.23,7c-1.75,2.89-9.76,1.78-9.9-.35a38,38,0,0,1,.32-6.66L57,373.1l1.1,1,1.57.87,2.49.06L64.3,374l1.1-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1652",
    "data-name": "Trac\\xE9 1652",
    className: "cls-14",
    d: "M53.57,371.19s1.84,5.16-.75,7.2c-1.35,1.06-4.17,1.74-7.36.46-2.9-1.16-6.25-4.22-6.25-4.77,0-1.17,4.46-2.89,4.46-2.89l1,2.25,2.06,1.36,2.63.2,1.62-.3,1.56-1.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_239",
    "data-name": "Groupe 239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1653",
    "data-name": "Trac\\xE9 1653",
    className: "cls-11",
    d: "M52.72,257.68c-.24,3.12-4.94,3.05-6.63,1.86l-2.24-6.78a.78.78,0,0,1,.46-1,.71.71,0,0,1,.41,0,.76.76,0,0,1,.59.48l1.4,4.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1654",
    "data-name": "Trac\\xE9 1654",
    className: "cls-1",
    d: "M52.72,257.68c-.24,3.12-4.94,3.05-6.63,1.86l-2.24-6.78a.78.78,0,0,1,.46-1,.71.71,0,0,1,.41,0,.76.76,0,0,1,.59.48l1.4,4.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1655",
    "data-name": "Trac\\xE9 1655",
    className: "cls-1",
    d: "M47.88,255.31a.78.78,0,0,0-.59-.48.66.66,0,0,0-.83.45.64.64,0,0,0,0,.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1656",
    "data-name": "Trac\\xE9 1656",
    className: "cls-11",
    d: "M49.44,254.92a.78.78,0,0,0-.59-.48.77.77,0,0,0-.9.62.81.81,0,0,0,0,.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1657",
    "data-name": "Trac\\xE9 1657",
    className: "cls-1",
    d: "M49.44,254.92a.78.78,0,0,0-.59-.48.77.77,0,0,0-.9.62.81.81,0,0,0,0,.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1658",
    "data-name": "Trac\\xE9 1658",
    className: "cls-11",
    d: "M49.58,255.33a.76.76,0,0,1,.47-1,.79.79,0,0,1,1,.44l.75,2.56v1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1659",
    "data-name": "Trac\\xE9 1659",
    className: "cls-1",
    d: "M49.58,255.33a.76.76,0,0,1,.47-1,.79.79,0,0,1,1,.44l.75,2.56v1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1660",
    "data-name": "Trac\\xE9 1660",
    className: "cls-1",
    d: "M53.57,371.19s1.84,5.16-.75,7.2c-1.35,1.06-4.17,1.74-7.36.46-2.9-1.16-6.25-4.22-6.25-4.77,0-1.17,4.46-2.89,4.46-2.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1661",
    "data-name": "Trac\\xE9 1661",
    className: "cls-1",
    d: "M56.12,371.19a37.91,37.91,0,0,0-.32,6.65c.14,2.13,8.15,3.24,9.91.35,1.12-1.86.22-7,.22-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1662",
    "data-name": "Trac\\xE9 1662",
    className: "cls-1",
    d: "M52.27,281.37l-6.12-21.76m5.64-2.27c.34-.09.82,0,.93.34l1.53,5.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1663",
    "data-name": "Trac\\xE9 1663",
    className: "cls-11",
    d: "M53.78,265.49v6.3a6.24,6.24,0,0,0,12.48,0v-6.3a6.24,6.24,0,1,0-12.48-.15v.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1664",
    "data-name": "Trac\\xE9 1664",
    className: "cls-1",
    d: "M53.78,265.49v6.3a6.24,6.24,0,0,0,12.48,0v-6.3a6.24,6.24,0,1,0-12.48-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1665",
    "data-name": "Trac\\xE9 1665",
    className: "cls-1",
    d: "M33.12,290.64,28.6,280l1.9-2.15M36.94,293,30.5,277.86l15.9-8.69,3.79,12.42m18.51-1.17c-2.59-2.67-9.91-.38-11.76-.41l-5.31,1.58m1.75,11.13-3.6,18.77a3.8,3.8,0,0,1-6.71,1.66L30,296.81A3.81,3.81,0,1,1,36,292l0,0,7.89,9.88,3.32-17.33a3.8,3.8,0,0,1,4.44-3h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1666",
    "data-name": "Trac\\xE9 1666",
    className: "cls-11",
    d: "M53.74,329.22l-.17,41a4.95,4.95,0,0,1-9.9,0l.85-46.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1667",
    "data-name": "Trac\\xE9 1667",
    className: "cls-1",
    d: "M53.74,329.22l-.17,41a4.95,4.95,0,0,1-9.9,0l.85-46.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1668",
    "data-name": "Trac\\xE9 1668",
    className: "cls-11",
    d: "M66,324.54v45.7a4.95,4.95,0,1,1-9.9,0l.84-41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1669",
    "data-name": "Trac\\xE9 1669",
    className: "cls-1",
    d: "M66,324.54v45.7a4.95,4.95,0,1,1-9.9,0l.84-41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1670",
    "data-name": "Trac\\xE9 1670",
    className: "cls-1",
    d: "M68.7,280.42c2.33,1.57,3.22,5.76,2.34,12-.5,3.52-3.55,7.24-3.62,11.34-.19,11.33-1.4,20.8-1.4,20.8.25,5.53-21.6,7-21.5-.36l-.1-9.6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1671",
    "data-name": "Trac\\xE9 1671",
    className: "cls-4",
    d: "M53.78,265.49A11.54,11.54,0,0,1,56.29,272c.13,1.57,1.61,5.84,4.07,6.07s5.71-2.33,5.81-5.18.58-9.62-1.22-11.19-5.07-3.2-8.37-1.37A5.27,5.27,0,0,0,53.78,265.49Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_440",
    "data-name": "Ligne 440",
    className: "cls-1",
    x1: 56.62,
    y1: 277.02,
    x2: 56.94,
    y2: 280.01
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_441",
    "data-name": "Ligne 441",
    className: "cls-1",
    x1: 64.25,
    y1: 276.52,
    x2: 64.25,
    y2: 279.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1672",
    "data-name": "Trac\\xE9 1672",
    className: "cls-2",
    d: "M132.36,317.2l.21,3.94a4.6,4.6,0,1,1-9.18.56,4.39,4.39,0,0,1,0-.89l.56-4.44,1.39,2.79,1.56.78,1.45.35,1.5-.2,1-.62,1.18-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1673",
    "data-name": "Trac\\xE9 1673",
    className: "cls-2",
    d: "M120.91,311.15v2.13a3.6,3.6,0,0,1-2.07,3.26l-7.5,3.54a3.61,3.61,0,0,1-3.39-.17l-1.8-1.07a2,2,0,0,1-.68-2.69,2,2,0,0,1,.58-.61l6.67-4.58.33,1.17.91,1.5,2.47,1.08,1.44-.21,1.76-.95.77-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1674",
    "data-name": "Trac\\xE9 1674",
    className: "cls-1",
    d: "M124,316.37l-.56,4.44a4.6,4.6,0,0,0,9.12,1.22,4.42,4.42,0,0,0,0-.89l-.21-3.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1675",
    "data-name": "Trac\\xE9 1675",
    className: "cls-1",
    d: "M112.72,311,106,315.54a2,2,0,0,0-.51,2.72,2.11,2.11,0,0,0,.61.58l1.8,1.07a3.61,3.61,0,0,0,3.39.17l7.5-3.54a3.58,3.58,0,0,0,2.07-3.26v-1.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1676",
    "data-name": "Trac\\xE9 1676",
    className: "cls-5",
    d: "M152.28,270.38c.19,3.07,2.1,6.34-1.41,8.68l-17.11,11.4-1.27,25.91a4.12,4.12,0,0,1-4.11,3.91h-.21a4.12,4.12,0,0,1-3.91-4.32l1.32-26.83a7.49,7.49,0,0,1,2.76-5.43l6.37-5.28a.29.29,0,0,0,0-.4l-.05,0a2,2,0,0,0-2.27,0l-10.2,6.85L121,310.71a4.1,4.1,0,0,1-4.1,3.91h-.21a4.11,4.11,0,0,1-3.91-4.31L114,284.57a8.52,8.52,0,0,1,4-6.8l13.12-8.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1677",
    "data-name": "Trac\\xE9 1677",
    className: "cls-1",
    d: "M152.28,270.38c.19,3.07,2.1,6.34-1.41,8.68l-17.11,11.4-1.27,25.91a4.12,4.12,0,0,1-4.11,3.91h-.21a4.12,4.12,0,0,1-3.91-4.32l1.32-26.83a7.49,7.49,0,0,1,2.76-5.43l6.37-5.28a.29.29,0,0,0,0-.4l-.05,0a2,2,0,0,0-2.27,0l-10.2,6.85L121,310.71a4.1,4.1,0,0,1-4.1,3.91h-.21a4.11,4.11,0,0,1-3.91-4.31L114,284.57a8.52,8.52,0,0,1,4-6.8l13.12-8.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1678",
    "data-name": "Trac\\xE9 1678",
    className: "cls-5",
    d: "M140.89,243.27a5.78,5.78,0,0,0,5.13-5.74v-5.82a5.77,5.77,0,1,0-11.54-.16v6a5.76,5.76,0,0,0,1.07,3.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1679",
    "data-name": "Trac\\xE9 1679",
    className: "cls-1",
    d: "M140.89,243.27a5.78,5.78,0,0,0,5.13-5.74v-5.82a5.77,5.77,0,1,0-11.54-.16v6a5.76,5.76,0,0,0,1.07,3.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1680",
    "data-name": "Trac\\xE9 1680",
    className: "cls-6",
    d: "M137,236.76c0,.28-.13.52-.3.52s-.3-.24-.3-.52.14-.53.3-.53.3.24.3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1681",
    "data-name": "Trac\\xE9 1681",
    className: "cls-7",
    d: "M137,236.76c0,.28-.13.52-.3.52s-.3-.24-.3-.52.14-.53.3-.53S137,236.47,137,236.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1682",
    "data-name": "Trac\\xE9 1682",
    className: "cls-6",
    d: "M140.34,237.17c0,.29-.14.52-.3.52s-.3-.23-.3-.52.13-.53.3-.53.3.24.3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1683",
    "data-name": "Trac\\xE9 1683",
    className: "cls-7",
    d: "M140.34,237.17c0,.29-.14.52-.3.52s-.3-.23-.3-.52.13-.53.3-.53S140.34,236.88,140.34,237.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1684",
    "data-name": "Trac\\xE9 1684",
    className: "cls-2",
    d: "M134.54,231.23c.34-5.15,5.27-5.29,6.57-5.23,4,.16,5.24,3.11,5,8.89,0,.56-.07,2.83-.07,2.27a42.11,42.11,0,0,0-1.73-4.75c-.41,3.85-9.75-1.17-9.75-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1685",
    "data-name": "Trac\\xE9 1685",
    className: "cls-1",
    d: "M134.54,231.23c.34-5.15,5.27-5.29,6.57-5.23,4,.16,5.24,3.11,5,8.89,0,.56-.07,2.83-.07,2.27a42.11,42.11,0,0,0-1.73-4.75C143.88,236.26,134.54,231.23,134.54,231.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1686",
    "data-name": "Trac\\xE9 1686",
    className: "cls-1",
    d: "M142.15,247.58a6.39,6.39,0,0,0,2.47-1.87v-4.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1687",
    "data-name": "Trac\\xE9 1687",
    className: "cls-1",
    d: "M144.62,243.31c2,.95,6.85,3.69,6.85,3.69a3.51,3.51,0,0,1,1.92,4.59h0l-6.92,16.91a3.52,3.52,0,0,1-3.26,2.18H143A3.5,3.5,0,0,1,139.8,268l-5.8-23.3a3.51,3.51,0,0,1,6.8-1.78.31.31,0,0,1,0,.08l1.16,4.63,2.05,8.25,2-4.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1688",
    "data-name": "Trac\\xE9 1688",
    className: "cls-1",
    d: "M139.77,268.13l-11.44-3a3.51,3.51,0,0,1-2.66-3.92l1.92-13.29c1.11-7.54,5.59-8.2,7.68-7.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1689",
    "data-name": "Trac\\xE9 1689",
    className: "cls-1",
    d: "M133.16,250.89,132,259l5.9,1.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1690",
    "data-name": "Trac\\xE9 1690",
    className: "cls-1",
    d: "M131.54,265.94a20.9,20.9,0,0,0-.38,3.95c0,6.48,20.27,5.68,21,1.27a9.53,9.53,0,0,0-.66-5.25c-.65-1.89-.21-9.26-.21-9.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1691",
    "data-name": "Trac\\xE9 1691",
    className: "cls-1",
    d: "M134,244.71c2.22.57,6.12,0,6.83-1.7m3.2,12.88.9,4.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1692",
    "data-name": "Trac\\xE9 1692",
    className: "cls-3",
    d: "M179.27,210.13c0,7-10.71,12.61-23.91,12.61s-23.91-5.65-23.91-12.61c0-4.35,4.18-8.18,10.54-10.45.29-.1-.15,2.29.15,2.19.83-.27.27,2,1.27,1.45.75-.42,1.18,1.84,2.19,1s2.79,1.29,3.78,0c.49-.65,2-1.82,2.25-3,.42-1.78-.44-3.56,0-3.6,1.21-.1,2.44-.15,3.7-.15h.81c.2,0-.43,2.32-.22,2.33.86,0,.37,1.65,1.31,1.42.59-.15,1.45,1.74,2.2,1.37s2.45.4,3.14-.31c1.2-1.24,1.27-4,2-3.83,8.6,1.91,14.64,6.4,14.64,11.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1693",
    "data-name": "Trac\\xE9 1693",
    className: "cls-2",
    d: "M151.63,201.28c3.7,7.73-.36,11-7.32,11-6.6,0-3.06-8.51-2.25-11l.65,1.42,1.59,1.14,2.3.94,4-.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_240",
    "data-name": "Groupe 240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1694",
    "data-name": "Trac\\xE9 1694",
    className: "cls-2",
    d: "M156.16,200.38v4.92a3.63,3.63,0,0,0,3,3.56l9.36,3.18a3.15,3.15,0,0,0,2.39-5.67l-6.51-7.24-1.8,3.2-3.44.25-1.89-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1695",
    "data-name": "Trac\\xE9 1695",
    className: "cls-1",
    d: "M156.16,200.38v4.92a3.63,3.63,0,0,0,3,3.56l9.36,3.18a3.15,3.15,0,0,0,2.39-5.67l-6.51-7.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1696",
    "data-name": "Trac\\xE9 1696",
    className: "cls-1",
    d: "M142.06,201.27c-.81,2.46-4.36,11,2.25,11,7,0,11-3.23,7.31-11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1697",
    "data-name": "Trac\\xE9 1697",
    className: "cls-5",
    d: "M141.12,154.16l.94,47.12c0,4,9.57,4.92,9.57,0l.38-43.67a1,1,0,0,1,2,0h0l1.75,41.23c0,4.58,8.68,5.84,8.61.33,0,0-1-53.84-1.31-58.78s-2.27-7-1.89-12.19c.32-4.35-.54-8.6-1-12.15-.23-1.94,1.74-4.55,3.56-5.3l17.9-7.31c1.46-.68,2.39-.84,2.39-2.45a4.15,4.15,0,0,0-4.15-4.15,4.34,4.34,0,0,0-1.47.26l-26.91,8.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1698",
    "data-name": "Trac\\xE9 1698",
    className: "cls-1",
    d: "M141.12,154.16l.94,47.12c0,4,9.57,4.92,9.57,0l.38-43.67a1,1,0,0,1,2,0h0l1.75,41.23c0,4.58,8.68,5.84,8.61.33,0,0-1-53.84-1.31-58.78s-2.27-7-1.89-12.19c.32-4.35-.54-8.6-1-12.15-.23-1.94,1.74-4.55,3.56-5.3l17.9-7.31c1.46-.68,2.39-.84,2.39-2.45a4.15,4.15,0,0,0-4.15-4.15,4.34,4.34,0,0,0-1.47.26l-26.91,8.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1699",
    "data-name": "Trac\\xE9 1699",
    className: "cls-1",
    d: "M186.7,100.87a6,6,0,0,1-3.18,1.48m-3.85-5.58,11.16-4.18a.72.72,0,0,1,.94.42.73.73,0,0,1-.38.93l-4.84,2.2m-23.47,44.21c1.13,1.73-10.55,7.43-18.76,6M141.47,142c.69-2.53,1.69-5.68,1.26-7.34-.64-2.46-4.39-7.11-4.11-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1700",
    "data-name": "Trac\\xE9 1700",
    className: "cls-1",
    d: "M142.84,96.45v5.28a5.23,5.23,0,1,0,10.46,0V96.45a5.23,5.23,0,0,0-10.46,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1701",
    "data-name": "Trac\\xE9 1701",
    className: "cls-1",
    d: "M144.1,105.06c1.16,4.54-.36,6.12-.36,6.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1702",
    "data-name": "Trac\\xE9 1702",
    className: "cls-15",
    d: "M151.53,105.85s-.52,3.06,0,4.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1703",
    "data-name": "Trac\\xE9 1703",
    className: "cls-1",
    d: "M151.53,105.85s0,5.34.5,6.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1704",
    "data-name": "Trac\\xE9 1704",
    className: "cls-1",
    d: "M183.78,98.34a3.6,3.6,0,0,1,1.87-.48c1.14,0,1.58-1.08.82-1.5a3.75,3.75,0,0,0-1.85-.24m3.58,2.48v1.62l-1.5.69a.72.72,0,0,1-1-.35.72.72,0,0,1,.35-1h0Zm.26-1.67v1.62l-1.5.69a.71.71,0,0,1-1-.34.72.72,0,0,1,.34-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1705",
    "data-name": "Trac\\xE9 1705",
    className: "cls-7",
    d: "M151.08,99.58c0,.29.13.52.3.52s.3-.23.3-.52-.13-.52-.3-.52-.3.24-.3.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1706",
    "data-name": "Trac\\xE9 1706",
    className: "cls-7",
    d: "M147.77,100c0,.29.13.52.3.52s.3-.23.3-.52-.13-.52-.3-.52-.3.24-.3.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1707",
    "data-name": "Trac\\xE9 1707",
    className: "cls-1",
    d: "M141.18,120.59l-6.53,10.5L142,143l3.46,5.56m-4.38,5.65-5-7.78L127.43,133a3.54,3.54,0,0,1,0-3.76l9.65-15.52c1.09-1.86,4.51-4.25,4.51-4.25.39.92,4.08,2.85,6.68,4.12a3.34,3.34,0,0,0,4.41-1.41,7.36,7.36,0,0,0,.69-6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1708",
    "data-name": "Trac\\xE9 1708",
    className: "cls-15",
    d: "M141.59,109.43c.61-1.23,2.91-2.12,2.91-2.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1709",
    "data-name": "Trac\\xE9 1709",
    className: "cls-1",
    d: "M141.59,109.43c.61-1.23,2.91-2.12,2.91-2.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1710",
    "data-name": "Trac\\xE9 1710",
    className: "cls-1",
    d: "M138.29,149.79a6,6,0,0,0,5.23-4.47m-2.4,8.84c1.92-.84,4.8-5,4.8-7.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1711",
    "data-name": "Trac\\xE9 1711",
    className: "cls-3",
    d: "M153.17,95.73c-.76,0-6.38,3.86-8.76-.08.27,2.38-1,4.58-1.59,4.69,0-3.78-1.76-9.55,5-9.62s6.15,4.16,5.4,5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1712",
    "data-name": "Trac\\xE9 1712",
    className: "cls-1",
    d: "M153.17,95.73c-.76,0-6.38,3.86-8.76-.08.27,2.38-1,4.58-1.59,4.69,0-3.78-1.76-9.55,5-9.62S153.92,94.87,153.17,95.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1713",
    "data-name": "Trac\\xE9 1713",
    className: "cls-1",
    d: "M186.72,96.18l2.11-1v1.62l-1.5.69"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBackground);
export default __webpack_public_path__ + "static/media/home-background.61a53f5fc51b969c72fafd324bbf67ae.svg";
export { ForwardRef as ReactComponent };